<app-masterpage>
</app-masterpage>
<div class="page-wrapper">
    <app-header>
    </app-header>
    <div class="footer-login custom-footer p-3">
        <p class="mb-0">Copyright © Netsol IT Solution Pvt. Ltd. 2020 All Rights Reserved</p>
        <img src="assets/images/powered-by.png" alt="netsol-powerd by" class="img-fluid">
    </div>
</div>